<template>
  <v-container
    ref="filters"
    class="my-0 py-0"
  >
    <v-row
      :class="rowClass"
      no-gutters
    >
      <v-col>
        <v-autocomplete
          v-if="hasGroupFilter"
          v-model="value.group"
          clearable
          single-line
          hide-details
          placeholder="Member Group"
          :items="filters.group"
          auto
          :disabled="disabled"
          item-text="name"
          item-value="id"
          @change="changed()"
          @click:clear="$nextTick(() => value.group = null)"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-if="hasMshipFilter"
          v-model="value.mShip"
          clearable
          single-line
          hide-details
          :class="{'ml-2': (hasGroupFilter)}"
          placeholder="Membership"
          :items="filters.mShip"
          auto
          :disabled="disabled"
          item-text="name"
          item-value="name"
          @change="changed()"
          @click:clear="$nextTick(() => value.mShip = null)"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-if="hasMtypeFilter"
          v-model="value.mType"
          clearable
          single-line
          hide-details
          :class="{'ml-2': (hasGroupFilter || hasMshipFilter)}"
          placeholder="Member Type"
          :items="filters.mType"
          auto
          :disabled="disabled"
          item-text="name"
          item-value="name"
          @change="changed()"
          @click:clear="$nextTick(() => value.mType = null)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'MemberSelectFilter',
  props: {
    disabled: Boolean,
    filters: {
      type: Object,
      default () {
        return {
          mType: [],
          mShip: [],
          group: []
        }
      }
    },
    value: {
      type: Object,
      default () {
        return {
          mType: null,
          mShip: null,
          group: null
        }
      }
    }
  },
  computed: {
    rowClass () {
      return 'mb-' + 12 / this.colCount
    },
    colCount () {
      var i = 0
      if (this.hasGroupFilter) i++
      if (this.hasMshipFilter) i++
      if (this.hasMtypeFilter) i++
      return i
    },
    hasGroupFilter () {
      return this.filters.group && this.filters.group.length > 1
    },
    hasMshipFilter () {
      return this.filters.mShip && this.filters.mShip.length > 1
    },
    hasMtypeFilter () {
      return this.filters.mType && this.filters.mType.length > 1
    }
  },
  // mounted () {
  //   const listEl = this.$refs.filters.closest('li')
  //   if (listEl) {
  //     listEl.addEventListener('click', (e) => {
  //       e.stopPropagation()
  //     })
  //   }
  // },
  methods: {
    changed () {
      this.$emit('input', this.value)
      this.$nextTick(() => this.$emit('change', this.value))
    }
  }
}
</script>
<style>
  .subheader .ftSelectFilter {
    width: 100%;
    display: flex;
  }
  .subheader .ftSelectFilter .input-group__input {
    height: 100%;
  }
  .subheader .ftSelectFilter .input-group {
    padding: 0;
  }
  .subheader .ftSelectFilter .input-group {
    padding: 0;
  }
  .subheader .ftSelectFilter .input-group--select__autocomplete {
    height: auto;
  }
  @media (max-width: 600px) {
    .subheader .ftSelectFilter .input-group--select__autocomplete::-webkit-input-placeholder {
      white-space:pre-line;
      position: relative;
      top: -8px;
      font-size: 12px;
    }
    .subheader .ftSelectFilter .input-group__selections__comma {
      font-size: 14px;
    }
  }

  .ftFilterHeader.subheader {
    height: auto;
    padding-bottom: 10px;
  }
</style>
